export default __webpack_public_path__ + "static/media/contact.1a208a93.png";